import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Icon from '../../App/Candidates/StudentApp/Icon';
import { WebProvider, useWeb } from './WebContext';
import './WebLayout.css';

export const WEB_BASE = '/student';

const links = [
  { to: WEB_BASE, end: true, icon: 'home', label: 'Home' },
  { to: `${WEB_BASE}/course`, icon: 'learn', label: 'Learn' },
  { to: `${WEB_BASE}/job`, icon: 'job', label: 'Jobs' },
  { to: `${WEB_BASE}/club`, icon: 'users', label: 'Clubs' },
  { to: `${WEB_BASE}/achievements`, icon: 'trophy', label: 'Achievements', also: `${WEB_BASE}/achievement` },
  { to: `${WEB_BASE}/activity`, icon: 'bell', label: 'For you' },
  { to: `${WEB_BASE}/profile`, icon: 'user', label: 'Profile' },
];

const WebSkeleton = () => (
  <div className="web-skeleton" role="status" aria-live="polite">
    <span className="web-sr">Loading</span>
    <i className="web-sk title" />
    <i className="web-sk line" />
    <div className="web-sk-grid">
      <i className="web-sk card" />
      <i className="web-sk card" />
      <i className="web-sk card" />
    </div>
    <i className="web-sk wide" />
  </div>
);

const WebShell = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { xp, theme, toast } = useWeb();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(false);
    const timer = window.setTimeout(() => setReady(true), 650);
    return () => window.clearTimeout(timer);
  }, [pathname]);

  return (
    <div className={`web-app${theme === 'dark' ? ' is-dark' : ''}`}>
      <aside className="web-side">
        <button type="button" className="web-brand" onClick={() => navigate(WEB_BASE)}>
          <Icon name="logo" />
          Focalyt
        </button>
        <nav aria-label="Student web">
          {links.map((link) => (
            <NavLink
              key={link.label}
              to={link.to}
              end={link.end}
              className={({ isActive }) => (isActive || pathname === link.also ? 'on' : '')}
            >
              <Icon name={link.icon} />
              {link.label}
            </NavLink>
          ))}
        </nav>
        <button type="button" className="web-me" onClick={() => navigate(`${WEB_BASE}/profile`)}>
          <span className="web-av">AS</span>
          <span>
            <b>Aditi Sharma</b>
            <small>{xp.toLocaleString()} XP · Level 7</small>
          </span>
        </button>
      </aside>
      <div className="web-main">
        <header className="web-top">
          <div>
            <strong>Student workspace</strong>
            <span>Courses, jobs, clubs and achievements</span>
          </div>
          <button type="button" className="web-icon" aria-label="For you" onClick={() => navigate(`${WEB_BASE}/activity`)}>
            <Icon name="bell" />
          </button>
        </header>
        <div className="web-body">
          <div className={ready ? 'web-page' : 'web-page is-pending'} aria-hidden={ready ? undefined : true}>
            <Outlet />
          </div>
          {ready ? null : <WebSkeleton />}
        </div>
      </div>
      {toast ? <div className="web-toast">{toast}</div> : null}
    </div>
  );
};

const WebLayout = () => (
  <WebProvider>
    <WebShell />
  </WebProvider>
);

export default WebLayout;
